var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 4.00065H14.6667V5.33398H13.3334V14.0007C13.3334 14.3689 13.0349 14.6673 12.6667 14.6673H3.33337C2.96519 14.6673 2.66671 14.3689 2.66671 14.0007V5.33398H1.33337V4.00065H4.66671V2.00065C4.66671 1.63246 4.96519 1.33398 5.33337 1.33398H10.6667C11.0349 1.33398 11.3334 1.63246 11.3334 2.00065V4.00065ZM12 5.33398H4.00004V13.334H12V5.33398ZM6.00004 7.33398H7.33337V11.334H6.00004V7.33398ZM8.66671 7.33398H10V11.334H8.66671V7.33398ZM6.00004 2.66732V4.00065H10V2.66732H6.00004Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.666204d83bbea6eb868825a806590660.svg";
export { ForwardRef as ReactComponent };